import React, { useState, useEffect } from "react";
import { Grid, Loader, Dimmer } from "semantic-ui-react";
import "./Agenda.scss";

export function Agenda() {
  const fechaActual = new Date();

  const nombresMeses = [
    "ENERO",
    "FEBRERO",
    "MARZO",
    "ABRIL",
    "MAYO",
    "JUNIO",
    "JULIO",
    "AGOSTO",
    "SEPTIEMBRE",
    "OCTUBRE",
    "NOVIEMBRE",
    "DICIEMBRE",
  ];

  const [calendarioCargado, setCalendarioCargado] = useState(false);

  const handleCalendarLoad = () => {
    setCalendarioCargado(true);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <>
      <Dimmer active={!calendarioCargado} inverted>
        <Loader>Espere un momento</Loader>
      </Dimmer>

      <Grid
        className="gridPage"
        stackable
        style={{
          display: calendarioCargado ? "flex" : "none",
        }}
      >
        <Grid.Row centered style={{ padding: "14px 14px 0px 14px" }}>
          <h2 className="tituloPage">
            AGENDA ÚNICA DE CAPACITACIÓN {fechaActual.getFullYear()} - MES DE{" "}
            {nombresMeses[fechaActual.getMonth()]} {fechaActual.getFullYear()}
          </h2>
        </Grid.Row>

        <Grid.Row centered style={{ padding: "0px 14px" }}>
          <iframe
            title="Calendario"
            className="calendario"
            src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23F1EFEF&ctz=America%2FArgentina%2FJujuy&showTitle=0&showDate=1&showPrint=0&showTabs=1&showCalendars=0&showTz=0&src=MzM0MDdhNjE2YzExY2YyMTA4MjNmMTg2YjJmNTA1MTI3ZjdkOGJkMzA1MzY3M2NjZTUzZDA4NmJjOWNlYzY4ZEBncm91cC5jYWxlbmRhci5nb29nbGUuY29t&color=%23A79B8E"
            onLoad={handleCalendarLoad}
          ></iframe>
        </Grid.Row>
      </Grid>
    </>
  );
}
